import { useEffect } from "react";
import { useMatch } from "react-router-dom";
import { useRecoilValue } from "recoil";

import {
  isLoggedInAtom,
  Log,
  storeCurrentPageAndRedirectToLogin,
} from "@ryde/shared";

export type UseAuthModel = ReturnType<typeof useAuth>;

export const initialUseAuthModel = {
  isLoggedIn: false,
};

export const useAuth = () => {
  const isLoginPage = useMatch("/login");

  const isLoggedIn = useRecoilValue(isLoggedInAtom);
  useEffect(() => {
    if (!isLoginPage && !isLoggedIn) {
      Log.debug("User logged out, navigating to login");
      storeCurrentPageAndRedirectToLogin();
    }
  }, [isLoggedIn, isLoginPage]);
  return { isLoggedIn };
};
